import React  from 'react'


import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {  faCircleUser, faXmark } from '@fortawesome/free-solid-svg-icons'


export default function UserMenu( { showText , centerTable } ) {


  function setCenterTable(  )
  {
      centerTable( "UserTable") ;
  }


  return (
    <div  >
        <div className=' drop-item' onClick={setCenterTable}>
          <FontAwesomeIcon  icon={faCircleUser} title='Users' 
          style={{color:'white' , height:25 , display:'inline'}}/>
          { showText  &&    (  <p style={{display:'inline'}}>  &nbsp; &nbsp;Add User</p> ) }
        </div>
        
    </div>
  )
}
